import { memo } from 'react';
import type { ApolloError } from '@apollo/client';
import { FormattedMessage } from 'react-intl';
import { AlertBanner, Text } from '@hst-horizon/horizon-ui';
import formatErrorMessage from '../util/formatErrorMessage';

const UnhandledError = ({
    children,
    noPadding,
}: {
    children?: Error | ApolloError;
    noPadding?: boolean;
}) => {
    let content: unknown = <FormattedMessage id="An Unknown Error Occurred." />;

    const errorMessage = formatErrorMessage(children);

    if (APP_ENV.VERBOSE_ERROR_BOX) {
        content = errorMessage;
    } else {
        // eslint-disable-next-line no-console
        console.error('Error caught');
        // eslint-disable-next-line no-console
        console.error(errorMessage);
    }

    return (
        <AlertBanner data-test-class="errorBox" noPadding={noPadding}>
            <Text primary>{content as string} </Text>
        </AlertBanner>
    );
};

export default memo(UnhandledError);
